import { Box, Container, Stack, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router'
import { ContainedButton } from '../../../components/Button'
import { CameraIcon, DipStripIcon, WaterSampleIcon } from '../../../components/icons'

interface StepProps {
  icon: React.ReactNode
  title: string
  description: string
}

const Step = ({ icon, title, description }: StepProps) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        // flex: 1,
        borderRadius: '50%',
        border: '1px solid #0F0E0E80',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: 300,
        height: 300,
        textAlign: 'center',
        px: 4,
        gap: 0.6,
      }}
    >
      {icon}
      <Typography
        fontSize={'1.2rem'}
        fontWeight={theme.typography.fontWeightBold}
        color={'primary.dark'}
      >
        {title}
      </Typography>
      <Typography
        fontSize={'1rem'}
        fontWeight={theme.typography.fontWeightMedium}
        color={theme.palette.grey[600]}
      >
        {description}
      </Typography>
    </Box>
  )
}

export const Steps = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: 'calc(100vh - 68px)',
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Stack alignItems="center" spacing={6}>
          <Typography
            fontSize={{xs: "2rem", md:'2.2rem'}}
            fontWeight={theme.typography.fontWeightBold}
            color='text.primary'
            textAlign={'center'}
          >
            How to Use Your Test Strip
          </Typography>

          <Stack direction={{xs: "column",  md:"row"}} spacing={4} justifyContent="center" alignItems="center" order={{xs: 1, md: 0}}>
            <Step
              icon={<WaterSampleIcon sx={{ fontSize: '6rem' }} />}
              title="Collect water sample"
              description="Collect water sample in a clean container"
            />
            <Step
              icon={<DipStripIcon sx={{ fontSize: '6rem' }} />}
              title="Dip the strip in"
              description="Dip the test strip inside the container filled with water."
            />
            <Step
              icon={<CameraIcon sx={{ fontSize: '6rem' }} />}
              title="Snap a photo"
              description="Clean your hands and use a fresh test strip"
            />
          </Stack>

          <ContainedButton
            size="large"
            onClick={() => navigate('/test-strip/upload')}
            sx={{
              py: 1.5,
              px: 4,
              
            }}
            
          >
            Continue to analysis
          </ContainedButton>
        </Stack>
      </Container>
    </Box>
  )
}
